import { post, get } from '../../../../services/request';

// Get Provider Site Unread RVU Details
export const getSiteRadUnReadRvuDetails = (payload) => {
    return post('SiteRadEnterprise/GetSiteRadEnterpriseUnReadRUVDetails', payload);
};

// Get Provider Site Read RVU Details
export const getSiteRadReadRvuDetails = (payload) => {
    return post('SiteRadEnterprise/GetSiteRadEnterpriseReadRUVDetails', payload);
};

// Export for Rad Hourly Volume Share to CSV
export const exportSiteHourlyVolumeShare = (url, payload) => {
    return post(url, payload);
};

// Get Dropdown values
export const getDropdownSiteRad = () => {
    return get('SiteRadEnterprise/GetSiteRadEnterpriseDropDown');
};

// get Worklist ID by RPCE IDs
export const getWorklistID = (payload) => {
    return post(`Common/GetWorkListByRPCEIds?rpceIds=${payload}`);
}

// get Practices by Worklist ID
export const GetPracticesByWorklistID = (payload) => {
    return get(`Common/GetPracticesByWorklistIds?worklistIds=${payload}`);
}

// get Practices by Worklist ID
export const GetSubPracticesByPracticeID = (payload) => {
    return get(`Common/GetSubPracticesByPracticeIDs?PracticeIDs=${payload}`);
}
